// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__cFLzQ","post-list":"Layout_post-list__g+uiM"};